module.exports = __webpack_public_path__ + "static/img/2.f820842.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/welcome/2.jpg
// module id = E871
// module chunks = 0